	<!--反馈列表-->
<template>
  <div>
  <el-form ref="searchForm"   label-width="240" :inline="true">		
  
	<el-form-item label="选择项目:" prop="name">
	  <el-select v-model="article" placeholder="请选择" style="width:200px" clearable @change="getNextType">
	    <el-option v-for="data in optionstype" :key="data.plot_id" :label="data.plot_name" :value="data.plot_id"></el-option>
	  </el-select>
	</el-form-item>
	  <el-form-item label="时间查询:">
	   <el-date-picker v-model="beginDate" type="date" style="height:35px" value-format="YYYY-MM-DD" ></el-date-picker><span style="padding: 0 15px;">-</span>
	   <el-date-picker v-model="endDate" type="date" style="height:50px" value-format="YYYY-MM-DD" ></el-date-picker>
	  </el-form-item>
  
	<el-form-item label="综合查询:" prop="name">
		<el-input v-model="tableDataName" placeholder="请输入名称" style="width:240px" clearable></el-input>
	</el-form-item>
    
	<el-form-item>
		<el-button type="primary" @click="queryMaterial()">搜索</el-button>
	</el-form-item>
	<!-- <el-form-item><el-button type="primary" @click="addMaterial()">新增</el-button></el-form-item> -->
  </el-form>
  <el-table :data="dataList" border  ref="multipleTable">
    <el-table-column label="序号"  width="100px">
    	<template v-slot="scope">
    		{{ scope.$index+1 }}
    	</template>
    </el-table-column>
    <el-table-column prop="user_name" label="反馈用户" ></el-table-column>
	<el-table-column prop="project" label="所属项目" ></el-table-column>
	<el-table-column prop="content" label="反馈内容" ></el-table-column>
	<el-table-column prop="status" label="是否处理" :formatter="formatter"></el-table-column>
	<el-table-column prop="create_time" label="添加时间" ></el-table-column>
	<el-table-column prop="update_time" label="更新时间" ></el-table-column>
    <el-table-column fixed="right" label="操作" width="300px" >
      <template v-slot="scope">
       <el-button  icon="el-icon-edit"    @click="Modify(scope.row)" type="success" size="small">编辑</el-button>
       <el-button  icon="el-icon-delete"   @click="Deleteinfo(scope.row)" type="danger" size="small">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
    <el-config-provider :locale="locale">
      <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pagesize"
            layout="total,sizes,prev,pager,next,jmper"
            :total="totalCount">
      </el-pagination>
    </el-config-provider>

    <rms_report_info @closeReportInfo="closeReportInfo"  v-if="reportInfoDialogVisible"></rms_report_info>
  </div>
</template>
<script>
import rms_report_info from './rms_report_info.vue'
//引入vue方法
import { ElConfigProvider } from 'element-plus';
//中文包
import zhCn from "element-plus/lib/locale/lang/zh-cn";
export default {

  name: 'ZhProvider',

  setup(){
    let locale = zhCn
    return{
      locale
    }
  },
	data() {
	  let self=this;
	  return {
		// ids:[],
	    dataList:[],  //表格数据集
	    reportInfoDialogVisible: false,
	    tableDataName:'',   //综合查询条件参数
	    optionsype:'',     //所属项目选项
	    project:'',       //选择的所属项目
		content:'',
		status:'',
		memo:'',
		create_time:'',
		update_time:'',
	    totalCount:0,          //总页数
	    pagesize:10,        //每页数量
	    currentPage:1,    //初始页
		article:'',
		beginDate:null,
		endDate:null,
		 optionstype:[],     //所属项目选项
	  }
	},

  /*启动后触发该方法*/
  created() {
	this.getplotname();
    this.handleClickQuery();
  },
  methods: {
	  getplotname:function(){
	    var self = this;
	    var redata = {};
	    redata.cmd = "getPmsName";
	    this.$sknet.postJson(this.$skconf("met.surl"), redata, function(datas){
	      this.optionstype=datas.datas.items;
	    }, function(data) {
	      self.$message(data.reason);
	    }, self);
	  },
	getNextType:function(data){
	  	
	},
    handleClickQuery:function(data){
      this.dataList = [];
      var req = {};
      req.cmd = "searchReportList";
      req.start=(this.currentPage-1) * this.pagesize;
      req.count=this.pagesize;
	  req.beginDate = this.beginDate;
	  req.endDate = this.endDate;
	  req.plot_id =this.article;
	  req.synthesize_params=this.tableDataName;
      this.$sknet.postJson(this.$skconf("met.surl"), req, function(res) {
        console.log(res);
        this.dataList=res.datas.items;
        this.totalCount=res.datas.totalCount;
      }, null, this);
    },
    Modify: function(item) {
      this.user_name = item.user_name+"";
	  this.id = item.id;
	  this.project = item.project;
	  this.content = item.content;
	  this.status = item.status;
	  this.memo = item.memo;
      this.reportInfoDialogVisible = true;
    },
    closeReportInfo:function(){
      this.reportInfoDialogVisible = false;
      this.handleClickQuery();
    },
    //条件查询的方法
    queryMaterial:function(){
        this.handleClickQuery();
    },
	
	Deleteinfo:function(item){
	  this.$confirm('是否确认删除?', '提示', {
	    confirmButtonText: '确定',
	    cancelButtonText: '取消',
	    type: 'warning'
	  }).then(() => {
	    this.deleteReport(item.id);
	  });
	},	
	deleteReport:function(id){
		var self = this;
		var req = {};
		req.id = id;
		req.cmd = "deleteReport"
		this.$sknet.postJson(this.$skconf("met.surl"), req, function(res){
		  self.$message("删除成功");
		  self.handleClickQuery();
		}, function(data) {
		}, self);
	},
    /*分页代码*/
    handleSizeChange: function (size) {
      this.pagesize = size;
      console.log(this.pagesize)  //每页下拉显示数据
    },
    handleCurrentChange: function(currentPage){
      this.currentPage = currentPage;
      this.handleClickQuery();
      console.log(this.currentPage)  //点击第几页

    },
	//根据返回值判断
	formatter:function(row,colum){
	  const status={
	    0:'未处理',
	    1:'已处理',
	  }
	  return  status[row.status];
	},
  },


  components: {
	  rms_report_info,
    [ElConfigProvider.name]: ElConfigProvider,
  },


}


</script>